<template>
    <div class="container-event-detail" id="scrollArea">
        <div
            class="img-event thumbnail-shadow"
            :style="`background-image : url(${returnImg(eventData.Thumb)})`"
        >
            <div class="thumbnail" :style="`background-image : url(${returnImg(eventData.Thumb)})`"></div>
        </div>
        <div class="wrap-etc-detail">
            <div class="text-etc">{{ eventData.e_grade }}</div>
            <div class="box-btn-etc">
                <button class="btn-share" @click="openShareModal()"></button>
                <button
                    class="btn-heart"
                    :class="{'active' : this.eventData.isLike}"
                    @click="toggleEventLike(eventData)"
                ></button>
                <div class="text-count-heart">{{ eventData.e_like }}</div>
            </div>
        </div>
        <div class="title-event-detail">{{ eventData.e_name }}</div>
        <div class="wrap-text-info pb40">
            <div class="box-text">
                <div class="text-left info">{{ $t('category') }}</div>
                <div class="text-right info">{{ eventData.ec_name ? eventData.ec_name : "-" }}</div>
            </div>
            <div class="box-text" v-if="eventData.e_time">
                <div class="text-left info">{{ $t('duration') }}</div>
                <div class="text-right info">{{ eventData.e_time }}</div>
            </div>
            <div class="box-text" v-if="eventData.e_address_name">
                <div class="text-left info">{{ $t('place') }}</div>
                <div class="text-right info">{{ eventData.e_address_name }}</div>
            </div>
            <div class="box-text mb0" v-if="eventData.e_start_date && eventData.e_end_date">
                <div class="text-left info">{{ $t('date') }}</div>
                <div class="text-right info">
                    {{
                    returnDateFormat(eventData.e_start_date, "YYYY.MM.DD")
                    }}~{{ returnDateFormat(eventData.e_end_date, "YYYY.MM.DD") }}
                </div>
            </div>
        </div>
        <div class>
            <div class="wrap-tab-content">
                <div class="wrap-text-detail notice">
                    <div class="text-title mb4">{{ $t('noti') }}</div>
                    <div class="text-content">{{ eventData.e_info }}</div>
                </div>
                <div class="wrap-text-detail pt24">
                    <div class="text-title">{{ $t('schedule') }}</div>
                    <div class="box-text detail mb8">
                        <div class="text-left detail">{{ $t('available_booking_time') }}</div>
                        <div class="text-right detail">{{ eventData.e_reservation }}</div>
                    </div>
                    <div class="box-text detail">
                        <div class="text-left detail">{{ $t('viewing_date_time') }}</div>
                        <div>
                            <div
                                class="text-right detail pb4"
                            >{{ returnDateFormat(eventData.e_start_date, "YYYY.MM.DD HH:mm") }}</div>
                            <div
                                class="text-right detail"
                            >- {{ returnDateFormat(eventData.e_end_date, "YYYY.MM.DD HH:mm") }}</div>
                        </div>
                    </div>
                </div>
                <div class="wrap-text-detail">
                    <div class="text-title">{{ $t('performance_details') }}</div>
                    <div
                        class="img-event detail"
                        :style="`background-image : url(${eventData.Detail[0].org_url})`"
                    ></div>
                </div>
                <div class="wrap-text-detail" v-if="eventData.e_address">
                    <div class="text-title">{{ $t('place') }}</div>
                    <div class="img-event place">
                        <gmap-map
                            :options="option"
                            :zoom="15"
                            :center="this.centerPosition"
                            style="width: 100%; height: 100%;"
                        >
                            <gmap-marker
                                :key="index"
                                :position="centerPosition"
                            ></gmap-marker>
                        </gmap-map>
                    </div>
                    <div class="box-text-address">
                        <div class="text-address pb4">{{ eventData.e_address }}</div>
                        <div class="text-address">{{ eventData.e_address_detail }}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="wrap-bottom">
            <div class="box-flex j-end">
                <button class="to-top" @click="moveTop()"></button>
            </div>
            <div>
                <div class="box-bottom">
                    <div class="event-status">{{ $t(returnTicketStatus(eventData.nTicketStatus)) }}</div>
                    <div class="event-nticket pt1 pb1">
                        <div class="text-nticket">{{ $t('linked_nticket') }}</div>
                        <div class="count-nticket">{{ eventData.u_publish_total }}</div>
                    </div>
                </div>
                <a class="btn-common btn" type="button" target='_blank' href="https://play.google.com/store/search?q=%EB%B0%8D%EA%B8%80%ED%8C%A8%EC%8A%A4&c=apps&hl=ko">{{$t('move_to_app')}}</a>
            </div>
        </div>
    </div>
</template>


<script>
import util from "@/mixins/util";
import EventCommentListComponent from "@/components/event/EventCommentListComponent.vue";
import EventCommentWriteComponent from "@/components/event/EventCommentWriteComponent.vue";
import dateMixins from "@/mixins/dateMixins";
import UtilityListComponent from "@/components/utility/UtilityListComponent.vue";
import { options } from "less";

export default {
    name: "EventDetailLayout",
    mixins: [dateMixins],
    components: {
        EventCommentWriteComponent,
        EventCommentListComponent,
        UtilityListComponent,
    },
    inject: ["toggleEventLike"],
    props: {
        eventData: {
            default: () => {},
        },
    },
    data() {
        return {
            centerPosition:{},
            eventKey: Number(this.$route.params.idx),
            userType: "",
            replyValue: 2,
            commentInput: "",
            locPlaces: [],
            existingPlace: null,
            option: {
                zoomControl: false,
                mapTypeControl: false,
                scaleControl: false,
                streetViewControl: false,
                rotateControl: true,
                fullscreenControl: false,
                disableDefaultUi: false,
                draggable : false,
            },
        };
    },
    beforeRouterEnter() {},
    created() {},
    mounted() {
        if (!util.isEmpty(this.eventData)) {
            this.centerPosition = {
                lat: Number(this.eventData.e_lat),
                lng: Number(this.eventData.e_long),
            };
        }
    },
    beforeUnmount() {},
    unmounted() {},
    computed: {},
    methods: {
        returnSnsArr(data) {
            const snsArr = [];
            if (!util.isEmpty(data.mb_sns_1)) {
                snsArr.push(data.mb_sns_1);
            }
            if (!util.isEmpty(data.mb_sns_2)) {
                snsArr.push(data.mb_sns_2);
            }
            if (!util.isEmpty(data.mb_sns_3)) {
                snsArr.push(data.mb_sns_3);
            }
            return snsArr;
        },

        checkInputText(targetTabIndex) {
            if (this.commentInput != "") {
                this.createConfirm({
                    title: this.$t("content_in_progress"),
                    content: this.$t("leave_delete_content"),
                    confirmText: this.$t("exit"),
                    cancelText: this.$t("stay"),
                    confirm: () => {
                        this.commentInput = "";
                        if (!util.isEmpty(targetTabIndex)) {
                            this.tabIndex = targetTabIndex;
                        }
                    },
                    cancel: () => {},
                });
            } else {
                if (!util.isEmpty(targetTabIndex)) {
                    this.tabIndex = targetTabIndex;
                }
            }
        },
        changeTab(data) {
            this.checkInputText(data);

            if (data === 3) {
                this.$nextTick(() => {
                    this.initChartConfig();
                });
            }
        },
        openShareModal() {
            let shareData = {
                path: `/event/${this.eventKey}`,
                image: this.eventData.Thumb[0].org_url,
                title: `${this.eventData.e_name} | 밍글패스(Minglepass)`,
                description: "밍글패스(Minglepass)",
                imageId: "",
                shareType: "event",
                detailKey: this.eventKey,
                shareTitle: "share",
            };
            this.$modal.show("share-modal", shareData);
        },
        returnImg(data) {
            if (util.isEmpty(data)) {
                return "";
            } else {
                return data[0].org_url;
            }
        },
        moveTop() {
            let scrollArea = document.getElementById(`scrollArea`);
            scrollArea.scrollTop = 0;
        },
        returnTicketStatus(status) {
            switch (status) {
                case 1:
                    return "stay_buy";
                case 2:
                    return "selling";
                case 3:
                    return "sell_end";
                default:
                    return "stay_buy";
            }
        },
    },
    watch: {},
};
</script>
